import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Endpoints } from '../../../api/Constants';
import { postLoginActions } from '../../../api/LoginInterface';
import { LoginResponseKeys } from '../../../api/LoginResponseKeys';
import Screens from '../../../screens';
import utils from '../../../utils';
import audio from '../../../utils/audio';
import { AUTH_TYPES } from '../../../utils/authFlow/constants';
import navigation from '../../../utils/navigation/navigation';
import routeParamConstants from '../../../utils/routeParamConstants';
import { setAuthorized, setRestart, setToken } from '../../actions/auth';
import { setPlayerId } from '../../actions/playerInfo';
import { setCasinoId } from '../../actions/playerInfo';
import { handleLoginErrorEvents } from '../../sagas/handleLoggerErrorEvents';
import gameVersion from '../../../utils/gameVersion';
export var postLoginMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.LOGIN),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  invalidatesTags: [{
    type: 'Login'
  }],
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, _ref) {
      var dispatch, queryFulfilled, _yield$queryFulfilled, _yield$queryFulfilled2, success, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context.sent;
              _yield$queryFulfilled2 = _yield$queryFulfilled.data;
              success = _yield$queryFulfilled2.success;
              data = _yield$queryFulfilled2.data;
              if (success) handleLoginSuccess(dispatch, data, args === null || args === void 0 ? void 0 : args.login_type);
              if (!success) handleLoginErrorEvents(data, args === null || args === void 0 ? void 0 : args.login_type);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              handleLoginErrorEvents(_context.t0, args === null || args === void 0 ? void 0 : args.login_type);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var postSSOLoginMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.SSO_LOGIN),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  invalidatesTags: [{
    type: 'Login'
  }],
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, _ref2) {
      var dispatch, queryFulfilled, _yield$queryFulfilled3, data, redirectionUrl;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled;
              _context2.prev = 1;
              _context2.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled3 = _context2.sent;
              data = _yield$queryFulfilled3.data;

              if (!data.success) {
                _context2.next = 10;
                break;
              }

              handleLoginSuccess(dispatch, data, AUTH_TYPES.MEMBER);
              _context2.next = 19;
              break;

            case 10:
              handleLoginErrorEvents(data, AUTH_TYPES.MEMBER);
              redirectionUrl = data.error_code === 'bbe3api_ssolog_2' && data.ssoAccountActivationRedirectionURL;

              if (!redirectionUrl) {
                _context2.next = 18;
                break;
              }

              if (!utils.isReactNative()) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return", redirectionUrl);

            case 15:
              window.location = redirectionUrl;
              _context2.next = 19;
              break;

            case 18:
              navigation.navigate(Screens.Start, _defineProperty({}, routeParamConstants.PARAM_STATUS_MESSAGE, data.error));

            case 19:
              _context2.next = 24;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](1);
              handleLoginErrorEvents(_context2.t0, AUTH_TYPES.MEMBER);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 21]]);
    }));

    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var postGuestLoginMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.GUEST_LOGIN),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  invalidatesTags: [{
    type: 'Login'
  }],
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, _ref3) {
      var dispatch, queryFulfilled, _yield$queryFulfilled4, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch = _ref3.dispatch, queryFulfilled = _ref3.queryFulfilled;
              _context3.prev = 1;
              _context3.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled4 = _context3.sent;
              data = _yield$queryFulfilled4.data;
              handleLoginSuccess(dispatch, data, AUTH_TYPES.GUEST);
              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](1);
              handleLoginErrorEvents(_context3.t0, AUTH_TYPES.GUEST);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 9]]);
    }));

    function onQueryStarted(_x5, _x6) {
      return _onQueryStarted3.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};

var handleLoginSuccess = function handleLoginSuccess(dispatch, data) {
  var loginMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : AUTH_TYPES.MEMBER;
  postLoginActions(loginMethod, true);
  dispatch(setPlayerId((data === null || data === void 0 ? void 0 : data.playerId) || (data === null || data === void 0 ? void 0 : data.player_id) || data[LoginResponseKeys.PLAYER_ID]));
  dispatch(setCasinoId((data === null || data === void 0 ? void 0 : data.casinoId) || (data === null || data === void 0 ? void 0 : data.casino_id) || data[LoginResponseKeys.CASINO_ID]));
  dispatch(setAuthorized(true));
  dispatch(setToken((data === null || data === void 0 ? void 0 : data.sessionId) || (data === null || data === void 0 ? void 0 : data.session_id) || data[LoginResponseKeys.AUTH_TOKEN]));
  dispatch(setRestart((data === null || data === void 0 ? void 0 : data.restartToken) || (data === null || data === void 0 ? void 0 : data.restart_token) || data[LoginResponseKeys.RETURN_TOKEN]));
  navigation.navigate(Screens.Lobby);
  audio.fadeOut('crowdsTalking');
  audio.playMusic('backgroundMusic');
};